export const InputType = {
    PRICE: 'PRICE'
};